import React, { Component } from "react";
import {
  TitleContainer,
  NewTitle,
  MyVideoContainer,
  MyVideoRoot,
} from "./MyVideo.style";
import qs from 'qs';
import i18n from '@/i18n';
import { connect } from 'react-redux'
import TemplatePage from "./InnerPages/TemplatePage";
import ShortsPage from "./InnerPages/ShortsPage";
import { ROUTE_PATH } from "@/utils/Global";

const MY_VIDEO_TABS = {
  TEMPLATE: "template",
  SHORTS: "shorts",
}

class MyVideoComponent extends Component {
    getSelectedTabFromPath = () => {
    try {
      const tab = (qs.parse(window.location.search, { ignoreQueryPrefix: true }) || {}).tab
      switch (tab) {
        case MY_VIDEO_TABS.TEMPLATE:
          return MY_VIDEO_TABS.TEMPLATE;
        case MY_VIDEO_TABS.SHORTS:
          return MY_VIDEO_TABS.SHORTS;
        default:
          return MY_VIDEO_TABS.TEMPLATE;
      }
    }
    catch (e) {
      return MY_VIDEO_TABS.TEMPLATE;
    }
  };
  state = {
    currentTabs: this.getSelectedTabFromPath(),
  };

  handleTabChange = (tab) => {
    const { history } = this.props;
    const { currentTabs } = this.state;
    if (currentTabs === tab) return;

    switch (tab) {
      case MY_VIDEO_TABS.TEMPLATE:
        history.replace(ROUTE_PATH.MY_VIDEOS_TEMPLATE);
        break;
      case MY_VIDEO_TABS.SHORTS:
        history.replace(ROUTE_PATH.MY_VIDEOS_SHORTS);
        break;
    }
  }

  renderInnerPage = () => {
    switch (this.getSelectedTabFromPath()) {
      case MY_VIDEO_TABS.TEMPLATE:
        return <TemplatePage {...this.props} />;
      case MY_VIDEO_TABS.SHORTS:
        return <ShortsPage {...this.props} />;
      default:
        return <TemplatePage {...this.props} />;
    }
  }

  render() {
    const { currentTabs } = this.state;
    return (
      <MyVideoRoot>
        <MyVideoContainer>
          <TitleContainer>
            <div className="left-side">
              <NewTitle>{i18n.t("myvideo.title")}</NewTitle>
            </div>
            <div className="center-side">
              <div className="type-switch-container">
                <div className={`type-switch-button ${currentTabs === MY_VIDEO_TABS.TEMPLATE ? 'active' : ''}`} onClick={() => this.handleTabChange(MY_VIDEO_TABS.TEMPLATE)}>
                  {i18n.t("global.template")}
                </div>
                <div className={`type-switch-button ${currentTabs === MY_VIDEO_TABS.SHORTS ? 'active' : ''}`} onClick={() => this.handleTabChange(MY_VIDEO_TABS.SHORTS)}>
                  {i18n.t("global.shorts")}
                </div>
              </div>
            </div>
            <div className="right-side"></div>
          </TitleContainer>
          {this.renderInnerPage()}
        </MyVideoContainer>
      </MyVideoRoot>
    );
  }
}

const mapStateToProps = state => ({

})

export const MyVideo = connect(mapStateToProps, null)(MyVideoComponent)

export const formatDate = videoDate => {
  const date = new Date(videoDate);
  const dateString = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .split("T")[0];
  const finalDate = dateString.replace(/-/g, ".");
  return finalDate;
};
